import { CirrusReservation } from "@glidevvr/cirrus-reservation-funnel";
import "@glidevvr/cirrus-reservation-funnel/styles.css";
import type { RootState } from "@/store";
import { useSelector } from "react-redux";
import { FunnelType } from "@/types/enums";
import { useUnitItemContext } from "@/hooks/useUnitItemContext";
import { ReservationType } from "@/types/enums";

interface UnitFunnelProps {
    type: string;
    selectedUnitId: number | string;
}
export const UnitFunnel = ({ selectedUnitId }: UnitFunnelProps) => {
    const { unitGroup: selectedUnitGroup, selectedPromo } =
        useUnitItemContext();

    const { funnelType } = useSelector((state: RootState) => state.journey);
    const apiKey = useSelector((state: RootState) => state.apiKey.apiKey);
    const environment = useSelector(
        (state: RootState) => state.apiKey.environment,
    );

    const showRentalFunnel = funnelType === FunnelType.RENT;
    const showReservationFunnel =
        funnelType === FunnelType.RESERVE || funnelType === FunnelType.QUOTE;

    return (
        <div>
            {showRentalFunnel && (
                <div
                    className="rental-funnel-root"
                    id={`unitFunnel${selectedUnitId}`}
                >
                    Funnel to Attach Here
                </div>
            )}
            {showReservationFunnel && (
                <CirrusReservation
                    apiKey={apiKey}
                    environment={environment ?? undefined}
                    facilityId={
                        selectedUnitGroup.representative_unit.facility_id
                    }
                    unitId={Number(selectedUnitId)}
                    promotionId={Number(selectedPromo)}
                    reservationType={ReservationType.HARD}
                    showDetails={false}
                    leadMode={funnelType === FunnelType.QUOTE}
                />
            )}
        </div>
    );
};
